import { Familiarity } from './familiarity';
import { IssueSeverityLevel } from './issueSeverityLevel';
import { IssueStatus } from './issueStatus';
import { ParagraphClause } from './paragraph';
import { LexibleTheme } from './theme';

export interface ContractIssue {
    categories: IssueCategory[];
    clauseNumbers: ParagraphClause[];
    createdAt: string;
    creationType: IssueCreationType;
    description: string;
    id: string;
    isNew: boolean;
    lastModifiedById: string;
    missingSuggestionLocations: ParagraphClause[];
    nonAssessedThemeIds: string[];
    nonAssessedThemes: LexibleTheme[];
    notes: string;
    organizationFamiliarity: Familiarity | null;
    paragraphOriginUuids: string[];
    paragraphIds: string[];
    propertyCode: string | null;
    lexiblePropertyId: string | null;
    public: boolean;
    reviewerIds: string[];
    relatedParagraphIds: string[];
    severityLevel: IssueSeverityLevel;
    stateInVersion: IssueStateInVersion;
    stateLabel: IssueStateInVersion | string;
    status: IssueStatus;
    title: string;
    updatedAt: string;
    versionId: string;
}

export enum IssueStateInVersion {
    NEW = 'New',
    UPDATED = 'Updated',
    CLOSED = 'Closed',
    UNCHANGED = 'Unchanged',
}

export interface IssueCategory {
    id: string;
    name: 'Compliance' | 'Uncommon Text' | 'Non-Contractual' | 'Commercial';
}

export enum IssueCreationType {
    AUTO = 'auto',
    MANUAL = 'manual',
}
